import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=63821726&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=ts"
export * from "./feedback.vue?vue&type=script&lang=ts"
import style0 from "./feedback.vue?vue&type=style&index=0&id=63821726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63821726",
  null
  
)

export default component.exports